export default "__VITE_ASSET__C40aVN5E__"